
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 40 40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.326 9l4.093 1.468L31 15.851l-3.581 2.447-1.535-1.468v13.7A37.333 37.333 0 0120 31a37.29 37.29 0 01-5.884-.469V16.83l-1.535 1.468L9 15.85l3.581-5.383L16.674 9c1.109 1.514 2.217 2.272 3.326 2.272s2.217-.758 3.326-2.272z","stroke":"#409EFF","stroke-width":"1.5","fill":"none"}})])
          )
        }
      }
    